module.exports = __webpack_public_path__ + "ubisoft-plus_rewards_program_desktop.webp";